<template>
  <div class="product-details">
    <div class="container">
      <div class="row">
        <div class="col-xl-6">
          <div class="product__details-nav d-sm-flex align-items-start">
            <ul class="nav nav-tabs flex-sm-column justify-content-between">

              <!-- <li v-for="(img, i) in product.related_images" :key="i" class="nav-item" role="presentation">
                <button @click="active_img = img" :class="`nav-link ${img === active_img ? 'active' : ''}`">
                  <img :src="img" alt="nav-img" class="nav-img">
                </button>
              </li> -->
            </ul>
            <div class="product__details-thumb">
              <div class="product__details-nav-thumb w-img">
                <img :src="product.image"  alt="product-img">
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6">
          <div class="product__details-content">
            <h6>{{ product.title }}</h6>
            <!-- <div class="pd-rating mb-10">
              <ul class="rating">
                <li v-for="n in 5" :key="n">
                  <a href="#"><i class="fal fa-star"></i></a>
                </li>
              </ul>
              <span>({{ product.reviews.length }} review)</span>
              <span><a href="#">Add your review</a></span>
            </div> -->
            <div class="price mb-10">
              <span>Rs {{ product.price }}</span>
            </div>
            <!-- 
            {{ product.price.toFixed(2) }}
            <div class="features-des mb-20 mt-10">
              <ul>
                <li v-for="(list, i) in product.feature_lists" :key="i">
                  <a href="#"><i class="fas fa-circle"></i>{{ list }}</a>
                </li>
              </ul>
            </div> -->
            <div class="product-stock mb-20">
              <h5>Availability: <span>{{ product.quantity === 0 ? 'Out of Stock' : 'In Stock' }}</span></h5>
            </div>
            <div class="cart-option mb-15">
              <div class="product-quantity mr-20">
                <div class="cart-plus-minus p-relative">
                  <input type="text" :value="cartStore.orderQuantity" disabled>
                  <div @click="cartStore.decrement" class="dec qtybutton">-</div>
                  <div @click="cartStore.increment" class="inc qtybutton">+</div>
                </div>
              </div>
              <a href="#" @click.prevent="cartStore.addCartProduct(product)" class="cart-btn">
                Add to Cart
              </a>
            </div>
            <!-- <div class="details-meta">
              <div class="d-meta-left">
                <div class="dm-item mr-20">
                  <a href="#" 
                 >
                   @click.prevent="wishlistStore.add_wishlist_product(product)" :class="isItemInWishlist(product) ? 'active' : ''" 
                    <i class="fal fa-heart"></i>
                    Add to wishlist
                  </a>
                </div>
                <div class="dm-item">
                  <a href="#" ><i class="fal fa-layer-group"></i>Compare</a>
                   @click.prevent="compareStore.add_compare_product(product)" :class="isItemInCompare(product) ? 'active' : ''" 
                </div>
              </div>
              <div class="d-meta-left">
                <div class="dm-item">
                  <a href="#"><i class="fal fa-share-alt"></i>Share</a>
                </div>
              </div>
            </div> -->
            <div class="product-tag-area mt-15">
              <div class="product_info">
                <span class="sku_wrapper">
                  <span class="title">SKU:</span>
                  <span class="sku">{{ product.product_code }}</span>
                </span>
                <span class="posted_in">
                  <span class="title">Categories:</span>
                  <a href="#">{{ product.category_name }}</a>
                </span>
                <span class="tagged_as">
                  <span class="title">Tags:</span>
                  <a href="#">{{ product.product_code }}</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref } from 'vue';
  import { useCartStore } from '@/stores/useCartStore';
  /*
  import { useWishlistStore } from "@/pinia/useWishlistStore";
  import { useCompareStore } from "@/pinia/useCompareStore";
  */
  
  export default {
    props: {
      product: Object // No type enforcement
    },
    setup(props) {
      const active_img = ref(props.product.image);
      const cartStore = useCartStore();

      /* const wishlistStore = useWishlistStore();
      const compareStore = useCompareStore();
  
      function isItemInWishlist(product) {
        return wishlistStore.wishlists.some(prd => prd.id === product.id);
      }
      function isItemInCompare(product) {
        return compareStore.compare_items.some(prd => prd.id === product.id);
      } */
  
      return {
        active_img,
        cartStore,
        /* wishlistStore,
        compareStore,
        isItemInWishlist,
        isItemInCompare */
      };
    }
  };
  </script>
  